import React from 'react';
import { Button, Form, Input, Label } from '../../../components/Bootstrap';
import { NobleModal } from '../../../components';

interface CopyModalProps {
  open: boolean;
  toggle: () => void;
  menus: any[];
  onSubmit: (fromMenuId, toMenuId) => void;
}

interface CopyModalState {
  fromMenuId: number | string;
  toMenuId: number | string;
}

const SELECT_OPTION = '----';

export class CopyModal extends React.Component<CopyModalProps, CopyModalState> {
  constructor(props) {
    super(props);

    this.state = { fromMenuId: SELECT_OPTION, toMenuId: SELECT_OPTION };
  }

  onSubmit = (e) => {
    e.preventDefault();

    this.props.onSubmit(this.state.fromMenuId, this.state.toMenuId);
  };

  onChangeFromMenu = (e) => {
    const newState: any = { fromMenuId: e.target.value };
    if (!this.state.toMenuId) {
      newState.toMenuId = this.props.menus.find((menu) => {
        return menu.id !== e.target.value;
      });
    }

    this.setState(newState);
  };

  onChangeToMenu = (e) => {
    const newState: any = { toMenuId: e.target.value };
    if (!this.state.fromMenuId) {
      newState.fromMenuId = this.props.menus.find((menu) => {
        return menu.id !== e.target.value;
      });
    }

    this.setState(newState);
  };

  render() {
    const fromMenus = this.props.menus.filter((menu) => {
      return menu.id !== this.state.toMenuId;
    });

    const toMenues = this.props.menus.filter((menu) => {
      return menu.id !== this.state.fromMenuId;
    });

    const canSubmit = this.state.fromMenuId !== SELECT_OPTION && this.state.toMenuId !== SELECT_OPTION;

    return (
      <NobleModal size='lg' isOpen={this.props.open} toggle={this.props.toggle}>
        <NobleModal.Title title='Copy Menu' />
        <NobleModal.Body>
          <p className='menu-modal-desc text-center'>Copy all menu items from one menu to another.</p>
          <Form onSubmit={this.onSubmit} className='menu-modal-input'>
            <div className='mt-5 mb-5'>
              <Label className='text-right' for='option'>
                From:
              </Label>
              <Input type='select' value={this.state.fromMenuId} onChange={this.onChangeFromMenu} required={true}>
                <option value={SELECT_OPTION}>{SELECT_OPTION}</option>
                {fromMenus.map((menu) => (
                  <option key={menu.id} value={menu.id}>
                    {menu.name}
                  </option>
                ))}
              </Input>
            </div>
            <div className='mt-5 mb-5'>
              <Label className='text-right' for='option'>
                To:
              </Label>
              <Input type='select' value={this.state.toMenuId} onChange={this.onChangeToMenu} required={true}>
                <option value={SELECT_OPTION}>{SELECT_OPTION}</option>
                {toMenues.map((menu) => (
                  <option key={menu.id} value={menu.id}>
                    {menu.name}
                  </option>
                ))}
              </Input>
            </div>
            <div className='text-center menu-modal-btns'>
              <Button type='button' color='link' className='me-4' onClick={this.props.toggle}>
                Cancel
              </Button>{' '}
              <Button disabled={!canSubmit} type='submit' color='primary'>
                Copy
              </Button>
            </div>
          </Form>
        </NobleModal.Body>
      </NobleModal>
    );
  }
}
